import React from 'react';
import { Lesson } from "../../../types";
import getSkillsIcon from '../../../utils/getSkillsIcon';
import ProgressBar from '../../ProgressBar/ProgressBar';
declare const I18n;

type Props = {
  lessons: Lesson[];
}

type SkillCount = {
  id: number;
  slug: string;
  count: number;
}

const Achievements: React.FunctionComponent<Props> = ({
  lessons
}: Props): JSX.Element => {
  
  const countSkills = (): SkillCount[] => {
    const skillMap = new Map<number, SkillCount>();
    
    lessons.forEach(lesson => {
      lesson.skills?.forEach(skill => {
        if (skillMap.has(skill.id)) {
          const existing = skillMap.get(skill.id)!;
          existing.count += 1;
        } else {
          skillMap.set(skill.id, {
            id: skill.id,
            slug: skill.slug,
            count: 1
          });
        }
      });
    });
    
    return Array.from(skillMap.values());
  };

  const skillCounts = countSkills();
  const totalSkills = skillCounts.reduce((sum, skill) => sum + skill.count, 0);

  if (totalSkills === 0) return null;

  return (
    <div className="course_overview">
      <h2>{I18n.t("models.lesson.achievements.achievements")}</h2>
      <div>        
        <div className="course_overview__skills">
          {skillCounts.map(skill => (
            <div key={skill.id} className="course_overview__skill_item">
              {getSkillsIcon(skill.slug)}
              <div className="course_overview__skill_info">
                <div className="course_overview__skill_label">
                  <h4>{I18n.t(`models.skills.attributes.${skill.slug}`)}</h4>
                  <p>{I18n.t("models.lesson.achievements.points", { point: skill.count })}</p>
                </div>
                <ProgressBar value={skill.count} total={totalSkills} displayStep={false} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Achievements;